import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// After a deploy, hashed chunk files referenced by an already-open tab no
// longer exist on the server, so lazy-route imports fail until the user
// refreshes. Reload once to pick up the new index.html; the timestamp guard
// prevents a reload loop if the chunk is missing for another reason, while
// still allowing recovery from a later deploy in the same tab.
const RELOAD_GUARD_KEY = "vite-preload-error-reloaded-at";
const RELOAD_GUARD_WINDOW_MS = 30_000;
window.addEventListener("vite:preloadError", (event) => {
  const lastReloadedAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY));
  if (Date.now() - lastReloadedAt < RELOAD_GUARD_WINDOW_MS) {
    return;
  }
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
